define('global/UI/SetupBP',[
	'jquery',
	'global/Logger',
	'./Helpers',
	'./ClickMenuNav',
    'plugins/tab',
    'plugins/slick',
	'plugins/jquery.matchHeight'
], function ($, Logger, Helpers, ClickMenuNav, Tab, Slick) {
	'use strict';

	Logger.debug('Setting up Best Plumbing JS Plugins...');
    
	$(function () {
		
		function debounce(func, wait, immediate) {
			var timeout;
			return function() {
				var context = this, args = arguments;
				var later = function() {
					timeout = null;
					if (!immediate) { func.apply(context, args); }
				};
				var callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) { func.apply(context, args); }
			};
		};

		//----------------------------------
		// Global Functions
		//----------------------------------
		
		// deleting only text (Not child selectors) in RoCbreadcrumbs
		 $("#hawkbreadcrumb .breadcrumbs").contents().filter(function () {
			 return this.nodeType === 3;
		 }).remove();

	    /* 
         * sliderMatchHeights
         * Add slider components to match in here.
         * any slieder with class slider wilh have its heights matched. 
         */
		 var sliderMatchHeights = debounce(function () {
		     var $ele = $(".slider");

		     $ele.each(function () {
		         var $this = $(this);
		         $this.find(".itemWrapper").matchHeights();
		         $this.find(".itemContent").matchHeights();
		         $this.find(".itemTitle").matchHeights();
		         $this.find(".reviewItem").matchHeights();
		         $this.find(".itemAction").matchHeights();
		     })

		     sliderMatchHeights();
		 }, 1000);

		 sliderMatchHeights();



	    //----------------------------------
	    // Header functions
	    //----------------------------------

	    // Quick Order trigger and accessibility functionality.

//		 $('html').click(function (e) {
//		     //e.preventDefault();
//		     var $this = $(this), $quickOrder = $('.quick-order');
//		     var trg = e.target.innerText;
//		     if (trg !== "") {
//		         if (trg != "Quick Order") {
//		             if ($quickOrder.hasClass('active')) {
//		                 $('.quick-order-trigger').removeClass('active');
//		                 $quickOrder.removeClass('active');
//		                 $this.removeClass('quick-order-opened');
//		             }
//		         }
//		     }
//		 });

		$(document).on('click', function(event) {
			if (!$(event.target).closest('.quick-order-trigger,.quick-order').length) {
				$("html").removeClass("quick-order-opened");
				$(".quick-order-trigger,.quick-order").removeClass("active");
			}
		});		

		 $('.quick-order-trigger').on('click', function (e) {
		     e.preventDefault();
			var $this = $(this), $html = $('html'), $quickOrder = $('.quick-order');
			if($this.hasClass('active')) {
				$this.removeClass('active');
				$quickOrder.removeClass('active');
				$html.removeClass('quick-order-opened');

			}
			else {
				$this.addClass('active');
				$html.addClass('quick-order-opened');
				$quickOrder.addClass("active");
				$quickOrder.focus();
				window.scrollTo(0, 0);

				$quickOrder.on('keydown', keyboardEvents);
			}

			function keyboardEvents(event) {
			 // If escape is pressed close element trigger a click on the close.
				if (event.keyCode == 27 ||$(".quick-order .endClose").is(":focus") ) {
					event.preventDefault();
					$('.quick-order-trigger').trigger('click');
					$('.header-links').find('.quick-order-link').next('li').find('a').focus();
				}
			}
		
		});
		
		//close .toggle-menu and .quick-order on resize
		var menuCloseOnResize = debounce (function (e) {
			$(".quick-order-trigger.active").trigger("click");
			if ( $("html").hasClass("cm-js-menu-active") ) {
				$(".toggle-menu").trigger("click");
			}
		}, 50);

		// append #quickOrderWrapper based on window width.
		var quickOrderWrapperAppender = debounce (function (e) {
			if ( $(window).outerWidth() >= 992 ) {
				$("#quickOrderWrapper").insertAfter(".quick-order-trigger")
			} else {
				$("#quickOrderWrapper").appendTo("#site-container")
			}
		}, 50);

		$(window).on("resize", quickOrderWrapperAppender);
		$(window).on("resize", menuCloseOnResize);

		//----------------------------------
		// Interior Pages
		//----------------------------------

		// Slick carousel on department page is only for mobile. Gridview is better on larger screens.
		var initDepartmentPageSlick = debounce(function () {
			if ($(window).outerWidth() > 768) {
				try {
					$('.department-page .productList.gridViewAlt .productListInner').slick("unslick");
				} catch (e){}
			} else {
				try { 
					$('.department-page .productList.gridViewAlt .productListInner').slick({
						arrows: true,
						slidesToShow: 1
					}); 
				} catch (e) {}	
			}
		}, 10);
		$(window).on("resize", initDepartmentPageSlick);


		/* Ticket Details: #621751 -> Header New */
	
		$(window).scroll(function() {
			if ($(window).width() > 991) {
				if ($(this).scrollTop() > 152){  
					$('.header__new-wrap').addClass("fixed-header");
				  }
				  else {
					$('.header__new-wrap').removeClass("fixed-header");
				}			
			}
			if ($(window).width() > 839 && $(window).width() < 992) {
				if ($(this).scrollTop() > 60){  
					$('.header__new-wrap').addClass("fixed-header");
				  }
				  else {
					$('.header__new-wrap').removeClass("fixed-header");
				}	
			}			
			if ($(window).width() > 599 && $(window).width() < 839) {
				if ($(this).scrollTop() > 50){  
					$('.header__new-wrap').addClass("fixed-header");
				  }
				  else {
					$('.header__new-wrap').removeClass("fixed-header");
				}	
			}	
			if ($(window).width() < 600) {
				if ($(this).scrollTop() > 45){  
					$('.header__new-wrap').addClass("fixed-header");
				  }
				  else {
					$('.header__new-wrap').removeClass("fixed-header");
				}			
			}									
		});		
		
		function triggerFocus(element) {
			var eventType = "onfocusin" in element ? "focusin" : "focus",
				bubbles = "onfocusin" in element,
				event;
		
			if ("createEvent" in document) {
				event = document.createEvent("Event");
				event.initEvent(eventType, bubbles, true);
			}
			else if ("Event" in window) {
				event = new Event(eventType, { bubbles: bubbles, cancelable: true });
			}
			element.focus();
			try {
				element.dispatchEvent(event);
			}catch(err) {}
		}

        $(document).ready(function () {
            $(".toggle-menu-btn").each(function () {
                $(this).on({
                    click: function (event) {
                        event.preventDefault();
                        $(this).toggleClass("active");
                        $(this).closest("body").toggleClass("sticky-nav-active");
						$(this).closest("body").find(".siteHeader.site__header").toggleClass("fixed-pos-mobile");
						$(this).closest("html").toggleClass("cm-js-menu-active");
                        //window.scrollTo(0, 0);
						if(!$(this).hasClass("active")) {
							$(this).attr("aria-expanded","false");
						} else {
							$(this).attr("aria-expanded","true");
							setTimeout(function() {
								triggerFocus($('.header__new-wrap > .header__new-wrapInner > .main-nav.nav-bar .cm-menu > li:first-child >a').eq(0));
							}, 100);
						}
						if($('.site-search').hasClass('active-search')) {
							$('.site-search').removeClass('active-search');
							$('#search-toggle-mobile').attr('aria-expanded', 'false');
							$('#querydiv').css('display', 'none');
						}												
                    }
                });
            });
			$('#search-toggle-mobile').on('click', function (e) {
				e.stopPropagation();
				if($('#search-toggle-mobile').attr('aria-expanded') == 'false'){
					$('#search-toggle-mobile').attr('aria-expanded', 'true');
					setTimeout(function() {
						triggerFocus($('#txtSearch').eq(0));
					  }, 100);					
				} else {
					$('#search-toggle-mobile').attr('aria-expanded', 'false');
					$('#querydiv').css('display', 'none');
				}
				$('.site-search').toggleClass('active-search');
				if($('.toggle-menu-btn').hasClass('active')) {
					$('.toggle-menu-btn').attr('aria-expanded', 'false').removeClass('active');
					$('body').removeClass("sticky-nav-active");
					$('.siteHeader.site__header').removeClass("fixed-pos-mobile");
					$('html').removeClass("cm-js-menu-active");
				}				
			});		

        });		

		$('.header__new-wrap > .header__new-wrapInner > .main-nav.nav-bar,.toggle-menu-btn,.site-search').on('click', function (e) {
			e.stopPropagation();
		});
	
		$(window).click(function() {
			if($('.toggle-menu-btn').hasClass('active')) {
				$('.toggle-menu-btn').attr('aria-expanded', 'false').removeClass('active');
				$('body').removeClass("sticky-nav-active");
				$('.siteHeader.site__header').removeClass("fixed-pos-mobile");
				$('html').removeClass("cm-js-menu-active");
			}
			if($('.site-search').hasClass('active-search')) {
				$('.site-search').removeClass('active-search');
				$('#search-toggle-mobile').attr('aria-expanded', 'false');
			}			
		  });

		  function mobileDropDownMenuTop() {
			var mobileRocToolsImpersonation = $(".roc-tools.roc-navbar.roc-navbar-impersonation");
			var mobileRocToolsImpersonationHeight = $(".roc-tools.roc-navbar.roc-navbar-impersonation").outerHeight();
			var mobileSiteHeaderHeight = $(".siteHeader.site__header").outerHeight();
			var mobileMenuTopHeight = mobileRocToolsImpersonationHeight + mobileSiteHeaderHeight;
			var mobileMenuTop = $(".header__new-wrap > .header__new-wrapInner > .main-nav.nav-bar");
			if(mobileRocToolsImpersonation.length > 0) {
				if ($(window).width() < 992) {
					mobileMenuTop.css("top", mobileMenuTopHeight + "px");
					$(".header__new-wrap > .header__new-wrapInner").css("top", mobileRocToolsImpersonationHeight + "px");					
				} else {
					mobileMenuTop.css("top", mobileMenuTopHeight + "px");
					$(".header__new-wrap > .header__new-wrapInner").css("top", mobileRocToolsImpersonationHeight + "px");						
				}
			} else {
				if ($(window).width() < 992) {
					mobileMenuTop.css("top", mobileMenuTopHeight + "px");			
				}
			}				
		};	
		
		$(window).bind("load resize", function() {
			setTimeout(function(){
				mobileDropDownMenuTop();
				var equalheightItemTitle = $('.productList.gridViewAlt');
				if (equalheightItemTitle.length){
					equalheight('.productList.gridViewAlt .item-title');
					equalheight('.productList.gridViewAlt .heading-best');
				}
			},500);		
            if ($(window).width() < 992) {
				$(".site__header .column-header-wrap-all-right .site-search").appendTo(".siteHeader.site__header");
            }
            else {
				$(".site__header .site-search").appendTo(".column-header-wrap-all-right");
            }
		});
		$(window).on("orientationchange", function(event) {
			setTimeout(function(){
				mobileDropDownMenuTop();
			},500);		
            if ($(window).width() < 992) {
				$(".site__header .site-search").appendTo(".siteHeader.site__header");
            }
            else {
				$(".site__header .site-search").appendTo(".column-header-wrap-all-right");
            }			
		});
		
		// $(document).ajaxSuccess(function (event, request, settings) {
		// 	if($('#hawkfacets').length){
		// 		if($('#hawkfacets .hawk-guidedNavWrapper > .hawk-navGroup').length < 19){
		// 			$('#hawkfacets').removeClass('facet-hidden').attr('aria-hidden', 'false');
		// 		}
		// 		for(var i = 0; i < $('#hawkfacets .hawk-guidedNavWrapper > .hawk-navGroup').length; i++){
		// 			if(i > 18){
		// 				$('#hawkfacets').addClass('facet-hidden');
		// 				$('#hawkfacets .hawk-guidedNavWrapper > .hawk-navGroup').eq(i).addClass('facet-hidden').attr('aria-hidden', 'true');
		// 			}
		// 		}				
		// 	}							
		// });	
		$(document).ajaxComplete(function( event, request, settings ) {
			var displayMode = $('.productList.multiLayoutList.tableView');
			if(displayMode.hasClass("listView")) {
				if (displayMode.length){
					displayMode.prev().find('[data-display-mode="grid-alt"]').removeClass('active');
					displayMode.prev().find('[data-display-mode="list"]').addClass('active');
				}	
			}
			var equalheightItemTitle = $('.productList.gridViewAlt');
			if (equalheightItemTitle.length){
				equalheight('.productList.gridViewAlt .item-title');
				equalheight('.productList.gridViewAlt .heading-best');			
			}		

		});

		$(document).on('click', ".roc-pageOptions-filter .listing-display-option", function () {
			var equalheightItemTitle = $('.productList.gridViewAlt');
			if (equalheightItemTitle.length){
				equalheight('.productList.gridViewAlt .item-title');
				equalheight('.productList.gridViewAlt .heading-best');
			}
		});	

	});

	// adding class to make green shop menu itesm a different color;
	var greenShopNavColor = function () {
		$(".main-nav .cm-menu li ul li a[href='/green-shop/']").addClass("green-shop");
		$(".main-nav .cm-menu li a[href='/green-shop/']").addClass("green-shop");
	}

	$(document).ready(function () {
		$(window).trigger("resize");
		greenShopNavColor();
	});
	


	/* Ticket Details: #621751 -> Header New */

	// Move .accountNav into navigation for mobile View.
	// This function is called after the template is rendered in siteHeader.js
	var accountNavPrepender = function () {
		var $accountNav = $(".header-links");
		//var $searchMobileMove = $(".site__header .site-search");
		if (Helpers.resizeObject.windowWidth >= Helpers.constantsObject.screenMediumMin) {
			$accountNav.prependTo(".headerMain .column-3");
			//$searchMobileMove.appendTo(".column-header-wrap-all-right");
		} else {
			$accountNav.prependTo(".header__new-wrap > .header__new-wrapInner > .main-nav.nav-bar");
			//$searchMobileMove.appendTo(".siteHeader.site__header");
		}
	};		

	// Pushing functions to corresponding event Arrays
	Helpers.resizeFunctionsArray.push(accountNavPrepender);

	var SetupGlobals = {
		accountNavPrepender: accountNavPrepender
	};	

	return SetupGlobals;

	// var SetupBP = {
	// 	memberNav: memberNav
	// };

	// return SetupBP;
});

